import { showMagnetBtn } from '../common/help_functions';

(function ($) {

    $(document).ready(function () {
        let slider = $('.section-top-slider .top-slider-wrap').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            autoplay: true,
            autoplaySpeed: 7000,
            nav: true,
            dots: false,
        });

        slider.on("afterChange", function (){
            let currentSlide = slider.find(".slick-current").index() + 1
            $(".slides-number-wrap .slide-number.-active").text("0" + currentSlide)

            showMagnetBtn('.hero-btn')
        })

        slider.on("beforeChange", function (){
            slider.find(".slick-current .is_on_screen_item").removeClass("is_on_screen")
            setTimeout(function () {
                slider.find(".slick-current .is_on_screen_item").addClass("is_on_screen")
            }, 100)
        })

        $(".slides-number-wrap .arrow").on("click", function () {
            if($(this).hasClass("-back")) {
                slider.find(".slick-prev").trigger("click")
            } else {
                slider.find(".slick-next").trigger("click")
            }
        })

    });

})(jQuery);

export function initTopSliderSection() {
    showMagnetBtn('.hero-btn')
}


// WEBPACK FOOTER //
// ./src/js/custom/section_top_slider.js